import { useEffect, useState } from 'react';

type ZoomPanModule = typeof import('react-zoom-pan-pinch');

let zoomPanPromise: Promise<ZoomPanModule> | null = null;
let zoomPanModule: ZoomPanModule | null = null;

const loadZoomPan = () => {
  if (!zoomPanPromise) {
    zoomPanPromise = import('react-zoom-pan-pinch').then(mod => {
      zoomPanModule = mod;
      return mod;
    });
  }
  return zoomPanPromise;
};

/** Lazily loads react-zoom-pan-pinch once; returns null until ready. */
const useZoomPanComponents = () => {
  const [mod, setMod] = useState<ZoomPanModule | null>(zoomPanModule);

  useEffect(() => {
    if (mod) {
      return undefined;
    }

    let cancelled = false;
    loadZoomPan().then(loaded => {
      if (!cancelled) {
        setMod(loaded);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [mod]);

  return mod;
};

export default useZoomPanComponents;
